import { ApplicationStatus } from 'types/enrollment/enrollment';
import { AppTag } from 'components/atoms';

const tagObjectByStatus = {
    [ApplicationStatus.NEW]: { color: '#2042E7', bg: '#CBD4FB', label: 'Nowy' },
    [ApplicationStatus.APPROVED]: { color: '#3E3E4B', bg: '#D1EFDE', label: 'Przyjęto' },
    [ApplicationStatus.REJECTED]: { color: '#DB2338', bg: '#FCEEEE', label: 'Odrzucono' },
};

export const ApplicationStatusTag = ({ status }: { status: ApplicationStatus }) => {
    const { label, color, bg } = tagObjectByStatus[status];

    return (
        <AppTag
            style={{
                color,
                backgroundColor: bg,
            }}
        >
            {label}
        </AppTag>
    );
};
